import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';
import {
  CustomFieldAppliesTo,
  CustomFieldDefinition,
  CustomFieldDefinitionRequest,
} from 'brain-data/model/custom-field.model';

/**
 * The custom-field DEFINITION administration surface (AC9). One request type serves create and
 * update, exactly as the server's `CustomFieldDefinitionRequest` does.
 *
 * Load carries its SUBJECT on both the request and the answer: the API is `appliesTo`-scoped and the
 * screen switches between FACILITY and BUILDING, so a slow answer for the subject the administrator
 * has just navigated away from must be identifiable as such rather than painted over the list they
 * are now looking at.
 */
export const loadCustomFieldDefinitions = createAction(
  '[CustomFieldDefinitions] load',
  props<{ appliesTo: CustomFieldAppliesTo }>(),
);
export const loadCustomFieldDefinitionsSuccess = createAction(
  '[CustomFieldDefinitions] load success',
  props<{ appliesTo: CustomFieldAppliesTo; definitions: CustomFieldDefinition[] }>(),
);
export const loadCustomFieldDefinitionsError = createAction(
  '[CustomFieldDefinitions] load error',
  props<{ error: HttpErrorResponse }>(),
);

export const createCustomFieldDefinition = createAction(
  '[CustomFieldDefinitions] create',
  props<{ payload: CustomFieldDefinitionRequest }>(),
);
export const createCustomFieldDefinitionSuccess = createAction(
  '[CustomFieldDefinitions] create success',
  props<{ definition: CustomFieldDefinition }>(),
);
export const createCustomFieldDefinitionError = createAction(
  '[CustomFieldDefinitions] create error',
  props<{ error: HttpErrorResponse }>(),
);

export const updateCustomFieldDefinition = createAction(
  '[CustomFieldDefinitions] update',
  props<{ id: number; payload: CustomFieldDefinitionRequest }>(),
);
export const updateCustomFieldDefinitionSuccess = createAction(
  '[CustomFieldDefinitions] update success',
  props<{ definition: CustomFieldDefinition }>(),
);
export const updateCustomFieldDefinitionError = createAction(
  '[CustomFieldDefinitions] update error',
  props<{ error: HttpErrorResponse }>(),
);

export const deleteCustomFieldDefinition = createAction(
  '[CustomFieldDefinitions] delete',
  props<{ id: number }>(),
);
export const deleteCustomFieldDefinitionSuccess = createAction(
  '[CustomFieldDefinitions] delete success',
  props<{ id: number }>(),
);
export const deleteCustomFieldDefinitionError = createAction(
  '[CustomFieldDefinitions] delete error',
  props<{ error: HttpErrorResponse }>(),
);
